import { useMemo } from 'react';
import { ChainID } from '@ankr.com/chains-list';

import { getSubChainFromGroup } from 'domains/chains/utils/getSubChainFromGroup';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';

import { Feature, MainEndpointsProps } from '../types';
import { getFeatureKeys } from '../utils/getFeatureKeys';
import { getFlattenURLs } from '../utils/getFlattenURLs';
import { getTitle } from '../utils/getTitle';
import { usePlaceholder } from './usePlaceholder';

export const useMainEndpoints = ({
  feature = Feature.RPC,
  group,
  publicChain,
}: MainEndpointsProps) => {
  const { urls } = group;

  const isMultiChain = publicChain.id === ChainID.MULTICHAIN;
  const isGraphQL = publicChain.id === ChainID.FUEL;

  const { isPremium } = useAccountStatus();

  const subChain = getSubChainFromGroup(group);

  const { hasPlaceholder, shouldSignIn } = usePlaceholder(subChain, isPremium);

  const urlKey = useMemo(() => getFeatureKeys(feature), [feature]);

  const [flattenURLs, urlsCount] = useMemo(
    () => getFlattenURLs({ urlKey, urls }),
    [urlKey, urls],
  );

  const title = useMemo(
    () =>
      getTitle({
        isGraphQL,
        isMultiChain,
        urlsCount,
      }),
    [isMultiChain, urlsCount, isGraphQL],
  );

  return {
    flattenURLs,
    hasPlaceholder,
    title,
    shouldSignIn,
  };
};
